export const colorSchemeNumberUtil = (x) => {
  let color =''
  x<40?color='red'
    :x>=40&&x<50?color='yellow'
      :x>=50&&x<90?color='blue':color='green'

  return color
}